import { useEffect, useState } from "react";
import { BIZ_PERSONAS } from "../mock";
import { useAuth } from "./auth";
import { getSite, setSite, SITE_EVT } from "./site";

const KEY = "vl-biz-persona";
export const PERSONA_EVT = "vl-persona-change";
let LOCKED = false;  // signed-in partners: the agency type lives on the server, browsing pricing tabs or persona pages never changes it
export const lockPersona = (on) => { LOCKED = !!on; };
export const isPersonaLocked = () => LOCKED;
export const getPersona = () => { const v = typeof window !== "undefined" ? localStorage.getItem(KEY) : null; return BIZ_PERSONAS.find((p) => p.id === v) || null; };
export const setPersona = (id, { force = false } = {}) => { if (LOCKED && !force) return; localStorage.setItem(KEY, id); window.dispatchEvent(new Event(PERSONA_EVT)); };
export function useBizPersona() {
  const [p, setP] = useState(getPersona);
  useEffect(() => { const h = () => setP(getPersona()); window.addEventListener(PERSONA_EVT, h); return () => window.removeEventListener(PERSONA_EVT, h); }, []);
  return p;
}

export function usePersonaSync() {
  const { user, updateProfile } = useAuth();
  useEffect(() => {
    lockPersona(!!user && user.role === "partner");
    if (!user) return;
    const local = getPersona();
    const site = getSite();
    const patch = {};
    const locked = user.role === "partner";  // partners: the agency type on the server always wins
    if (user.persona && (!local || (locked && local.id !== user.persona))) setPersona(user.persona, { force: true });
    else if (!locked && local && local.id !== user.persona) patch.persona = local.id;
    if (user.site && !site) setSite(user.site);
    else if (site && site !== user.site) patch.site = site;
    if (Object.keys(patch).length) updateProfile(patch).catch(() => {});
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const onPersona = () => { const p = getPersona(); if (user && p && p.id !== user.persona) updateProfile({ persona: p.id }).catch(() => {}); };
    const onSite = () => { const s = getSite(); if (user && s && s !== user.site) updateProfile({ site: s }).catch(() => {}); };
    window.addEventListener(PERSONA_EVT, onPersona);
    window.addEventListener(SITE_EVT, onSite);
    return () => { window.removeEventListener(PERSONA_EVT, onPersona); window.removeEventListener(SITE_EVT, onSite); };
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps
}
